import React from 'react';
import { Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { CardsListCard } from '@yme/molecules/cards/cards-list-card';
import { CardsListCardSizes } from '@yme/molecules/cards/cards-list-card/constants';
import { buildKey } from '@yme/utils/common';
import { ColStyled } from './styled';
export function CardsWithTitlesGrid(props) {
    const { cards, isRemoveBottomIndent, learnMoreLabel, isRightToLeft } = props;
    const isCardHasOddLength = cards.length % 2 === 1;
    if (!cards.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            React.createElement(Row, { justifyContent: "flex-start" }, cards.map((card, index) => {
                const isLastCard = cards.length === index + 1;
                const { title, image, link } = card;
                const subtitle = card?.subtitle || '';
                if (isLastCard && isCardHasOddLength) {
                    return (React.createElement(ColStyled, { lg: 12, key: buildKey(index, title) },
                        React.createElement(CardsListCard, { title: title, subtitle: subtitle, image: image, link: link, learnMoreLabel: learnMoreLabel, isRightToLeft: isRightToLeft, size: CardsListCardSizes.LARGE })));
                }
                return (React.createElement(ColStyled, { lg: 6, key: buildKey(index, title) },
                    React.createElement(CardsListCard, { title: title, subtitle: subtitle, image: image, link: link, learnMoreLabel: learnMoreLabel, size: CardsListCardSizes.SMALL, isRightToLeft: isRightToLeft })));
            })))));
}
